import axios from 'axios'
import store from '@/store'

export default {
  getCountries () {
    return new Promise((resolve, reject) => {
      axios.get('/api/countries', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('countries/setCountries', res.data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },
  getTimeZones () {
    return new Promise((resolve, reject) => {
      axios.get('/api/time-zones', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('countries/setTimeZones', res.data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  }
}
